export default "__VITE_ASSET__DI1P9aS8__"